<template>
    <el-dialog
        :visible.sync="hide_show_bulk_edit_non_coverage_popup"
        :close-on-click-modal="false"
        :full-screen="true"
        custom-class="bulk-edit-hourly-modal"
        :modal-append-to-body="false"
        @closed="closeBulkEditHourlyModal"
        >
        <el-row :gutter="20" class="mb-3">
            <el-col :span="24">
                <div style="display: flex; justify-content: space-between" class="mb-2">
                    <h2 class="popup-title">Bulk Edit Non-coverage activities</h2>
                    <span class="cursor-pointer" style="font-size: 28px; color: #333;" @click="closeBulkEditHourlyModal">
                        <i class="el-icon-circle-close"></i>
                    </span>
                </div>
            </el-col>
        </el-row>
        <el-row :gutter="20" class="mt-2">
            <el-col :span="12">
                <p class="font-bold py-1">Activities</p>
                <el-select
                    v-model="selected_hourly_activities_ids"
                    filterable
                    multiple
                    collapse-tags
                    style="width: 100%"
                    placeholder="Select Activity"
                    size="small"
                >
                    <el-option
                        v-for="(activity, activityIndex) in activity_type_list"
                        :key="activityIndex"
                        :value="activity.id"
                        :label="activity.name"
                        :disabled="!all_unique_hourly_activities.includes(activity.id) ? true : false"
                    >
                        {{ activity.name }}
                    </el-option>
                </el-select>
            </el-col>
            <el-col :span="12">
                &nbsp;
            </el-col>
        </el-row>
        <el-row :gutter="20" class="mt-2">
            <el-col :span="12">
                <p class="font-bold py-1">Start Time</p>
                <el-select
                    v-model="selected_hourly_view_start_time"
                    style="width: 100%"
                    filterable
                    size="small"
                    placeholder="Select time"
                    :disabled="!selected_hourly_activities_ids || !selected_hourly_activities_ids.length"
                >
                    <el-option
                        v-for="(element, elementIndex) in nonCoverageDailyViewLabelsComputed"
                        :key="'start-time-index-'+elementIndex"
                        :value="element.label"
                        :label="element.value"
                    ></el-option>
                </el-select>
            </el-col>
            <el-col :span="12">
                <p class="font-bold py-1">End Time</p>
                <el-select
                    v-model="selected_hourly_view_end_time"
                    style="width: 100%"
                    size="small"
                    filterable
                    :disabled="!selected_hourly_view_start_time"
                    placeholder="Select time"
                >
                    <el-option
                        v-for="(element, elementIndex) in nonCoverageDailyViewLabelsComputed"
                        :key="'end-time-index-'+elementIndex"
                        :value="element.label"
                        :label="element.value"
                    ></el-option>
                    <!-- :disabled="disableTimeElementForHourlyViewBulkEditEndTimeDropDown(element.label) ? true : false" -->
                </el-select>
            </el-col>
        </el-row>
        <el-row :gutter="20" class="mt-2">
            <el-col :span="12">
                <p class="font-bold py-1">Day(s)</p>
                <el-select
                    v-model="selected_hourly_view_days"
                    filterable
                    multiple
                    collapse-tags
                    style="width: 100%"
                    placeholder="Select Days"
                    size="small"
                    :disabled="!selected_hourly_view_start_time"
                >
                    <el-option
                        v-for="(dayItem, dayIndex) in daysList"
                        :key="dayIndex"
                        :value="dayItem.value"
                        :label="dayItem.label"
                        :disabled="(selected_hourly_view_days.includes('all') && dayItem.value != 'all') || (selected_hourly_view_days.length && !selected_hourly_view_days.includes('all') && dayItem.value == 'all') ? true : false"
                    ></el-option>
                </el-select>
            </el-col>
            <el-col :span="12">
                <p class="font-bold py-1">No. of people</p>
                <el-input
                    v-model="selected_hourly_view_number_of_people"
                    v-mask="'###'"
                    style="width: 100%"
                    placeholder="No. of people"
                    size="small"
                    :disabled="!selected_hourly_view_days.length ? true : false"
                >
                </el-input>
            </el-col>
        </el-row>
        <el-row :gutter="20" class="mt-4">
            <el-col :span="24" class="text-right">
                <el-button
                    type="warning"
                    class="primary-settings-button__save"
                    round
                    size="small"
                    :disabled="bulkEditHourlyFormDisabled"
                    @click="bulkUpdateNonCoverageHourlyData"
                >Update</el-button>
            </el-col>
        </el-row>
    </el-dialog>
</template>

<script>
import settingsMixin from '../../../../../../mixins/settingsMixin';
export default {
    name: "BulkEditNonCoverageActivitiesOld",
    mixins: [settingsMixin],
}
</script>

<style lang="scss">
.bulk-edit-hourly-modal {
    .el-dialog__header {
        display: none;
    }
}
</style>